export default "__VITE_PUBLIC_ASSET__3c4599ec__"